import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiAlertTriangle, FiDownload, FiCheck } = FiIcons;

const ScamTips = () => {
  const tips = [
    {
      icon: FiAlertTriangle,
      title: "Gift Card Red Flag",
      tip: "If they're asking for iTunes gift cards to 'unlock your prize,' block and move on, sweetie."
    },
    {
      icon: FiShield,
      title: "Tech Support Reality Check",
      tip: "Microsoft doesn't call you about viruses. That's your first clue it's a scam, darling."
    },
    {
      icon: FiCheck,
      title: "Romance Scammer Test",
      tip: "If your online lover needs money for an 'emergency' after two weeks, it's not love — it's a con."
    },
    {
      icon: FiAlertTriangle,
      title: "IRS Impersonator Alert",
      tip: "The IRS doesn't threaten arrest over the phone. They send letters like civilized people."
    },
    {
      icon: FiShield,
      title: "Banking Verification Rule",
      tip: "Don't give that 'prize winner' your routing number. Banks don't work that way, honey."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
      <div className="container mx-auto px-6">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-pink-500 to-cyan-400 bg-clip-text text-transparent">
            Linda's Scam Survival Tips
          </h2>
          <p className="text-xl text-gray-300">
            Street-smart wisdom to keep you safe online
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {tips.map((tip, index) => (
            <motion.div
              key={index}
              className="group"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-pink-500/50 transition-all duration-300 transform hover:scale-105 h-full">
                <div className="flex items-start gap-4">
                  <div className="bg-gradient-to-br from-pink-500 to-purple-600 p-3 rounded-lg flex-shrink-0">
                    <SafeIcon icon={tip.icon} className="text-xl text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-white text-lg mb-3 group-hover:text-pink-400 transition-colors">
                      {tip.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      "{tip.tip}"
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="bg-gray-800 p-8 rounded-2xl border border-pink-500/30 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Want More Protection?
            </h3>
            <p className="text-gray-300 mb-6">
              Download Linda's complete Scam Survival Guide — packed with red flags, 
              prevention tips, and what to do if you've been targeted.
            </p>
            <button className="bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-3 mx-auto shadow-lg">
              <SafeIcon icon={FiDownload} className="text-xl" />
              Download Free Guide
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ScamTips;